// Module
var code = "<textarea class=\"_data full\" name=\"title\" value=\"{{value}}\"></textarea> ";
// Exports
export default code;